/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ImportSystemsComponent } from '../../components/import-systems/import-systems.component';
import { GlobalConstants } from '../../constants/global-constants';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class ImportSystemsDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = ImportSystemsComponent;
    sysquePopupConfig.data = null;
    sysquePopupConfig.height = 700;
    sysquePopupConfig.width = 780;
    sysquePopupConfig.componentTitle = GlobalConstants.ImportSystemTitle;
  }
}
